import { Injectable } from '@angular/core';
import { IApiRouteService } from '../../models/route';
import { ApiFilesSaPlasticDto } from '../dto/sa-plastic.dto';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApiFilesPlasticService extends IApiRouteService {
  urlRoute = environment.otherApis.files + '/api/plastic';
  constructor(protected readonly http: HttpClient) {
    super();
  }

  postImage(
    body: ApiFilesSaPlasticDto['postImage']['body']
  ): Observable<ApiFilesSaPlasticDto['postImage']['return']> {
    const formData = new FormData();
    formData.append('file', body.file);

    formData.append('departament', body.departament);
    formData.append('type', body.type);
    formData.append('root', body.root.toString());
    formData.append('version', body.version.toString());
    formData.append('imageType', body.imageType);
    return this.http.post<ApiFilesSaPlasticDto['postImage']['return']>(
      `${this.urlRoute}/image`,
      formData
    );
  }

  postScrapImage(
    body: ApiFilesSaPlasticDto['postScrapImage']['body']
  ): Observable<ApiFilesSaPlasticDto['postScrapImage']['return']> {
    const formData = new FormData();
    formData.append('file', body.file);
    formData.append('moldRevisionId', body.moldRevisionId);
    formData.append('partId', body.partId);
    formData.append('department', body.department);
    formData.append('type', body.type);
    return this.http.post<ApiFilesSaPlasticDto['postScrapImage']['return']>(
      `${this.urlRoute}/scrap-mold/image`,
      formData
    );
  }

  /** URLs de las imágenes de scrap de una revisión de molde. */
  getScrapMoldImages(
    moldRevisionId: number
  ): Observable<ApiFilesSaPlasticDto['getScrapMoldImages']['return']> {
    return this.http.get<ApiFilesSaPlasticDto['getScrapMoldImages']['return']>(
      `${this.urlRoute}/scrap-mold/${moldRevisionId}/images`
    );
  }

  getImage(
    moldId: number,
    query: ApiFilesSaPlasticDto['getImage']['query'],
    passAsImageUrl = false
  ): Observable<{ data: number[]; imageUrl?: string }> {
    const params = new HttpParams({
      fromObject: {
        version: query.version.toString(),
        imageType: query.imageType,
      },
    });
    const obs = this.http.get<{ data: number[] }>(
      `${this.urlRoute}/image/${moldId}`,
      { params }
    );
    if (passAsImageUrl) {
      return obs.pipe(
        map((res) => {
          const arrayData = new Uint8Array(res.data);
          let binary = '';
          arrayData.forEach((el) => (binary += String.fromCharCode(el)));
          const imageUrl =
            `data:image/${query.imageType};base64,` + window.btoa(binary);
          return { ...res, imageUrl };
        })
      );
    }
    return obs;
  }
  getImageByUrl(url: string): Observable<Blob> {
    return this.http.patch(
      this.urlRoute + '/image-url',
      { url },
      { responseType: 'blob' }
    );
  }

  createScrapSelection(
    body: ApiFilesSaPlasticDto['createScrapSelection']['body']
  ): Observable<any> {
    return this.http.post(`${this.urlRoute}/scrap-selection`, body);
  }

  getScrapSelection(moldId: number, partId: number): Observable<any> {
    return this.http.get(`${this.urlRoute}/mold/${moldId}/part/${partId}`);
  }
}
